module.exports = __webpack_public_path__ + "static/img/arrow-down-gray.9d6388f2.svg";